module.exports = "https://web-assets.ifttt.com/packs/media/applet_card/install-f958b298.svg";